module.exports = __webpack_public_path__ + "img/iPhone5_sml-933c4e1c55d3a4617e08a498f19a7cc3.png";